import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
declare let getData: any;

@Component({
  selector: "app-media",
  templateUrl: "./newsroom.component.html",
  styleUrls: ["./newsroom.component.css"],
})
export class NewsroomComponent implements OnInit {
  constructor(public router: Router) {
    getData();
  }

  ngOnInit(): void {
    document.documentElement.style.setProperty(
      "--color",
      !(this.router.url === "/home" || this.router.url === "/")
        ? "black"
        : "white"
    );
    
  }

}
